import React from 'react';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import { Theme, withStyles, createStyles } from '@mui/material/styles';

import { Button, Card } from '@mui/material/';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import './avatar-with-badge.scss';





export interface IAvatarWithBadgeProps {
  avatar: any;
  getPreviousStep?(): void;
  previousLink?: string;
  hideButton?: boolean;
  icon?: boolean;
  title?: string[];
  text?: string[];
  showAvatar?: boolean;
}

const AvatarWithBadge = (props: IAvatarWithBadgeProps) => {


  const {
    avatar,
    getPreviousStep,
    previousLink,
    hideButton,
    icon,
    title,
    text,
    showAvatar
  } = props || {};



  return (
    <div className={'header-avatar-badge' + ' header-avatar-bottom-space' }>
      <div className="avatar">


      
          <div>
     
              <Avatar  alt="Remy Sharp" src={avatar} />
          </div>

      </div>
        <Card className="header-badge-text-box">
          {icon && (
            <div className="check-icon">
              <img src={'/content/images/mobile-view/check.svg'} />
            </div>
          )}
          {title?.map((textItem, index) => {
            return (
              <div key={index}>
                <div className="text-msg-acceuil" content={textItem} />
              </div>
            );
          })}
          {text?.map((textItem, index) => {
            return (
              <React.Fragment key={index}>
                <div content={textItem}>{textItem}</div>
                {/* <br /> */}
              </React.Fragment>
            );
          })}
        </Card>

    </div>
  );
};
export default AvatarWithBadge;
